import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForAccidentalDeathAndDismemberment: 'false',
    groupName: '',
    relationshipToInsured: '',
    address: '',
    cityOrTown: '',
    state: '',
    postalCode: '',
    country: '',
    phoneNumber: '',
    dateOfAccident: '',
    dateOfDismembermentOrLossOfUse: '',
    dateOfDeath: '',
    dates: '',
    hospitalConfined: 'false',
    hospital: '',
    addressForHospital: '',
    cityOrTownForHospital: '',
    countryForHospital: '',
    postalCodeForHospital: '',
    describeHowTheAccidentOccurred: '',
    // For Common
    areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment: 'false',
    groupNameForCommon: '',
    relationshipToInsuredForCommon: '',
    addressForCommon: '',
    cityOrTownForCommon: '',
    stateForCommon: '',
    postalCodeForCommon: '',
    countryForCommon: '',
    phoneNumberForCommon: '',
    dateOfAccidentForCommon: '',
    dateOfDismembermentOrLossOfUseForCommon: '',
    dateOfDeathForCommon: '',
    datesForCommon: '',
    hospitalConfinedForCommon: 'false',
    hospitalForCommon: '',
    addressForHospitalForCommon: '',
    cityOrTownForHospitalForCommon: '',
    countryForHospitalForCommon: '',
    postalCodeForHospitalForCommon: '',
    describeHowTheAccidentOccurredForCommon: '',
  },
  errors: [],
});

function accidentalDeathAndDismembermentStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default accidentalDeathAndDismembermentStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/reducer.js